import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cbg",
  "use": "icon-cbg-usage",
  "viewBox": "0 0 375 170",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 375 170\" id=\"icon-cbg\">\r\n  <defs>\r\n    <linearGradient gradientUnits=\"userSpaceOnUse\" x1=\"42.859375\" y1=\"390.75\" x2=\"370.75\" y2=\"390.75\" id=\"icon-cbg_LinearGradient2624\">\r\n      <stop id=\"icon-cbg_Stop2625\" stop-color=\"#3d85ed\" offset=\"0\" />\r\n      <stop id=\"icon-cbg_Stop2626\" stop-color=\"#3d85ed\" stop-opacity=\"0\" offset=\"1\" />\r\n    </linearGradient>\r\n  </defs>\r\n  <g transform=\"matrix(1 0 0 1 -41 -305 )\">\r\n    <path d=\"M 41 325  A 20 20 0 0 1 61 305 L 396 305  A 20 20 0 0 1 416 325 L 416 455  A 20 20 0 0 1 396 475 L 61 475  A 20 20 0 0 1 41 455 L 41 325  Z \" fill-rule=\"nonzero\" fill=\"url(#icon-cbg_LinearGradient2624)\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cbg.svg
// module id = l5HG
// module chunks = 0